import React, { useEffect, useState } from "react";
import Pagination from "../../../../../Shared/Pagination";
import { Modal } from "antd";
import PrescriptionDetails from "../../../../ConsultationNotes/VitalTabs/ViewPrescription/PrescriptionDetails";
import PatientService from "../../../../../../Services/PatientService";
import ConsultationService from "../../../../../../Services/ConsultationService";

function PrecriptionTable({ data, selectedPatient }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState({});
  const itemsPerPage = 5;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data?.length / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const handleClick = async (record) => {
    let patientPayload = {
      patientId: record?.patientId,
    };
    let consultationPayload = {
      consultationId: record?.consultationId,
      detailsYN: "Y",
    };
    try {
      const patientResponse = await PatientService.PatientListFilter(
        patientPayload
      );
      const consultationResponse = await ConsultationService.getPrescriptions(
        consultationPayload
      );
      if (consultationResponse.data) {
        setSelectedPrescription(consultationResponse.data[0]);
        setIsModalOpen(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div className={` m-auto rounded-lg flex justify-center`}>
        <table className={`w-full m-0`}>
          <thead className="py-2">
            <tr>
              <th>Patient Name</th>
              <th>Appointment Id</th>
              <th>Consultation Reason</th>
              <th>Doctor Name</th>
              <th>Clinic Name</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
            <tr>
              <td className="p-2 bg-[#f6f6f6]" colSpan={12}></td>
            </tr>
          </thead>
          <tbody className="text-center">
            {currentItems?.map((item, idx) => (
              <tr key={idx}>
                <td>{item.patientName}</td>
                <td>{item.appointmentId}</td>
                <td>{item.consultationReason}</td>
                <td>{item.userName}</td>
                <td>{item.clinic_Name}</td>
                <td>
                  {item?.consultationDate
                    ? item.consultationDate.slice(0, 10)
                    : ""}
                </td>
                <td>
                  <button
                    onClick={() => handleClick(item)}
                    className="text-brand-White p-2 bg-brand-primaryColor text-white rounded-md cursor-pointer"
                  >
                    View prescription
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="relative bottom-[-10px] right-8 flex justify-end my-2">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          containerClassName="mb-4"
          buttonClassName="border border-gray-300 md:px-3 px-2 bg-white rounded-full md:py-1 py-0.5 transition duration-300 ease-in-out focus:outline-none hover:bg-gray-200"
          activeButtonClassName="bg-blue-500 rounded-full"
        />
      </div>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        style={{ top: 20 }}
        width={"70%"}
        footer={[]}
        destroyOnClose
      >
        <PrescriptionDetails
          prescription={selectedPrescription}
          selectedPatient={selectedPatient}
        />
      </Modal>
    </div>
  );
}

export default PrecriptionTable;
